/* eslint 'array-callback-return': 'off','no-new-object': 'off','no-array-constructor': 'off' */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { getRequestsList } from 'action/facilitiesAction';
import styles from './Modules/GreenArrowTable.module.css';
import dropdownStyles from 'components/FacilityRequestComponents/AH/Modules/CustomDropDown.module.css';
import clock from 'Assets/images/access_time_green.svg';
import redundantIcon from 'Assets/images/redundantRequest.svg';
import moment from 'moment';

//Following function shall fetch all the requests and display request only based on selected zone

class AfterHoursMyRequests extends Component {

    componentDidMount() {
        this.props.getRequestsList(); //Fetch all the requests
    }

    constructor(props) {
        super(props);
        this.state = {
            completeRequets: null,
            selectedZoneDetail: null,
            filteredRequests: null,
            recordsCount: 0,
            redirect_to_viewAfterHoursRequest: false,
            viewAfterHoursRequestID: null,
        };

        this.filterAndSortRequests = this.filterAndSortRequests.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.splitDates = this.splitDates.bind(this);
        this.setStartAndEndTime = this.setStartAndEndTime.bind(this);
        this.convertUTCString = this.convertUTCString.bind(this);
        this.checkInprogress = this.checkInprogress.bind(this);
        this.checkRequestStatus = this.checkRequestStatus.bind(this);
        this.getZoneLocalDate = this.getZoneLocalDate.bind(this);
        this.getZoneLocalDateTime = this.getZoneLocalDateTime.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if (this.props.completeRequestsLists !== nextProps.completeRequestsLists) {
                this.setState({ completeRequets: nextProps.completeRequestsLists }, () => { this.filterAndSortRequests() });
            }
            else if (this.props.selectZoneDetails !== nextProps.selectZoneDetails) {
                this.setState({ selectedZoneDetail: nextProps.selectZoneDetails }, () => { this.filterAndSortRequests() });
            }
        }
    }

    viewAfterHoursRequest(afterHoursRequestID) {
        this.setState({ viewAfterHoursRequestID: afterHoursRequestID, redirect_to_viewAfterHoursRequest: true });
    }

    checkRequestStatus(statusValue, startDateTime, stopDateTime, key) {
        if (statusValue === 1) {  //Active request
            return (this.checkInprogress(startDateTime, stopDateTime, key)) ?
                <p className={styles.inProgressText}><img src={clock} alt="Trane Logo" className={styles.home_screen_icons} /><span>{"In Progress"}</span></p>
                : null;
        }
        else if (statusValue === 4) {  //Redundant Request
            return <p className={styles.redundantText}><img src={redundantIcon} alt="Trane Logo" className={styles.home_screen_icons} /><span>{"Redundant request"}</span></p>;
        }
        else {
            return null;
        }
    }

    getZoneLocalDate() {
        let { selectedZoneDetail } = this.state;
        var localTime = new Date();
        var utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
        let zoneOffset = null;
        zoneOffset = (selectedZoneDetail !== undefined) ? selectedZoneDetail.timeZoneOffset : 0;
        let localZoneTime = new Date(utc + (3600000 * zoneOffset));
        let CurrentDateOfZone = localZoneTime.toISOString().split('T')[0];
        return moment(CurrentDateOfZone).format('YYYY-MM-DD');
        //return localZoneTime;
    }

    getZoneLocalDateTime() {
        let { selectedZoneDetail } = this.state;
        var localTime = new Date();
        var utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
        let zoneOffset = null;
        zoneOffset = (selectedZoneDetail !== undefined) ? selectedZoneDetail.timeZoneOffset : 0;
        let localZoneTime = new Date(utc + (3600000 * zoneOffset));
        return localZoneTime;
    }

    render() {

        let { filteredRequests, recordsCount, viewAfterHoursRequestID, redirect_to_viewAfterHoursRequest } = this.state;
        let content = null;
        //Redirect to view maintenance page
        if (redirect_to_viewAfterHoursRequest) {
            return <Redirect to={{ pathname: '/FacilityManagement/ViewAfterHoursRequest/VAHR=' + viewAfterHoursRequestID }} />
        }

        if (filteredRequests !== null) {
            if (Object.keys(filteredRequests).length > 0) {
                content = Object.keys(filteredRequests).map((key, index) => {
                    //  if (moment(key).isAfter(this.convertToDate(new Date())) || moment(key).isSame(this.convertToDate(new Date()))) {
                    //       if (moment(key).isAfter(moment().format('YYYY-MM-DD')) || moment(key).isSame(moment().format('YYYY-MM-DD'))) {
                    if (moment(key).isAfter(this.getZoneLocalDate()) || moment(key).isSame(this.getZoneLocalDate())) {
                        return <div className={styles.dateContainer} key={index}><div className={styles.tableHeader}><p className={styles.dateHeading}>{this.convertUTCString(key)}</p></div>
                            <div className={styles.arrowTableContainer}>
                                {filteredRequests[key].map((e, idx) => (
                                    <div key={idx} className={(idx % 2 === 0) ? styles.requestOddRecordBox : styles.requestEvenRecordBox} onClick={() => { this.viewAfterHoursRequest(e.changeRequestId) }}>
                                        <div className={styles.timeBox}>{this.setStartAndEndTime(e.startDateTime, e.stopDateTime, key)} </div>
                                        <div className={styles.contentBox}>
                                            <p className={styles.requestText}> {e.requestComment} </p>
                                            <p className={styles.requestText}> {"Requested by "}{e.createdBy} </p>
                                            {this.checkRequestStatus(e.status, e.startDateTime, e.stopDateTime, key)}
                                        </div>
                                        <div className={styles.arrowBox}> <p className={styles.requestArrowIcon} onClick={() => { this.viewAfterHoursRequest(e.changeRequestId) }}></p></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                });
            }
            else {
                content = <p className={styles.requestText}>No Requests available</p>
            }

        }


        return (
            <div>
                <div className={styles.filterContainer}>
                    <p className={styles.sortText}>Sort:</p>
                    <span className={dropdownStyles.customDropdown} style={{ float: 'left' }}>
                        <select onChange={this.sortChange} style={{ width: '165px' }}>
                            <option key={1} value={1}>Date (Ascendings)</option>
                            <option key={2} value={2}>Date (Descending)</option>
                        </select>
                    </span>
                    <p className={styles.recordsCountText}> {recordsCount}{" of "}{recordsCount}{" afterhour requests shown."}</p>
                </div>
                {content}
            </div>
        );
    }

    filterAndSortRequests() {
        let { completeRequets, selectedZoneDetail } = this.state;
        if (selectedZoneDetail !== null && selectedZoneDetail !== undefined && completeRequets !== null && completeRequets !== undefined) {
            if (completeRequets.length !== 0) {
                //Filter requests based on zone ID
                let requestsOfSelectedZone = null;
                requestsOfSelectedZone = completeRequets.filter(element => element.zoneId === selectedZoneDetail.zoneId);

                if (requestsOfSelectedZone.length !== 0) {
                    let Data = new Object();
                    let count = 0;
                    requestsOfSelectedZone.map((e, index) => {
                        let splitDatesArray = this.splitDates(e.startDateTime, e.stopDateTime);
                        count = count + splitDatesArray.length;
                        let record = e;
                        splitDatesArray.forEach((element) => {
                            if (Data.hasOwnProperty(element)) {
                                Data[element].push(record);
                            }
                            else {
                                Data[element] = new Array();
                                Data[element].push(record);
                            }
                        });
                    }
                    );

                    this.setState({ filteredRequests: Data, recordsCount: count });
                }
                else {
                    // No requests at All 
                    //return no requests 
                    this.setState({ filteredRequests: {}, recordsCount: 0 });
                }
            }
            else {
                // No requests at All 
                //return no requests 
                console.log("No requests at all");
            }
        }
        //filter requests based on zones
    }

    sortChange(event) {
        //1 - Date ascending, 2- Date descending, 3- Newest, 4-Oldest.
        //Sort data in filtered requests state and setState
        if (this.state.filteredRequests !== null) {
            let newArray = new Object();
            Object.keys(this.state.filteredRequests).reverse()
                .forEach((key) => {
                    newArray[key] = new Array();
                    newArray[key] = this.state.filteredRequests[key];
                });
            this.setState({ filteredRequests: newArray });
        }
    }

    splitDates(startDate, stopDates) {
        var dateArray = [];
        let startDateTime = startDate.split('T')[0];
        let endDateTime = stopDates.split('T')[0];
        var currentDate = moment(startDateTime).format('YYYY-MM-DD');
        var stopDate = moment(endDateTime).format('YYYY-MM-DD');
        if (currentDate === stopDate) {
            dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
            return dateArray;
        }
        else if (moment(stopDate).isAfter(currentDate)) {
            while (moment(stopDate).isAfter(currentDate) || moment(currentDate).isSame(stopDate)) {
                dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
                currentDate = moment(currentDate).add(1, 'days');
            }
            return dateArray;
        }

        // while (currentDate <= stopDate) {
        //     dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
        //     currentDate = moment(currentDate).add(1, 'days');
        // }
        // return dateArray;
    }

    convertUTCString(keyDate) {
        let days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
        let mon = ["JAN", "FEB", "MAR", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
        let day = days[new Date(keyDate).getUTCDay()];
        let date = new Date(keyDate).getUTCDate();
        let month = mon[new Date(keyDate).getUTCMonth()];
        let year = new Date(keyDate).getUTCFullYear();
        return day + ", " + month + " " + date + ", " + year;
    }

    checkInprogress(start, End, key) {

        let currentDate = start.split('T')[0];
        let stopDate = End.split('T')[0];

        var startDateTime = moment(currentDate).format('YYYY-MM-DD');
        var endDateTime = moment(stopDate).format('YYYY-MM-DD');

        if (moment(startDateTime).isSame(endDateTime)) {
            return true;
        }
        else {
            let splitStartTime = null;
            let splitEndTime = null;
            let multipleDaysArray = null;
            multipleDaysArray = this.splitDates(startDateTime, endDateTime);
            if (multipleDaysArray.indexOf(key) === 0) {
                splitStartTime = moment(start).format('HH:mm');
                splitEndTime = "23:59";
            }
            else if (multipleDaysArray[multipleDaysArray.length - 1] === key) {
                splitStartTime = "00:00";
                splitEndTime = moment(End).format('HH:mm');
            }
            else if (multipleDaysArray.includes(key)) {
                // In Middle
                splitStartTime = "00:00";
                splitEndTime = "23:59";
            }
            let CombinedStartDateTime = moment(key + ' ' + splitStartTime);
            let CombinedEndDateTime = moment(key + ' ' + splitEndTime);
            let zonelocalDateTime = moment(this.getZoneLocalDateTime()).format('YYYY-MM-DDTHH:mm:ss');
            let isCurrent = moment(zonelocalDateTime).isBetween(CombinedStartDateTime, CombinedEndDateTime);
            return isCurrent;
        }

    }



    setStartAndEndTime(start, End, key) {

        let data = null;
        let startDateTime = start.split('T')[0];
        let endDateTime = End.split('T')[0];

        //if startDate and End Date are same  return only hours
        if (moment(startDateTime).isSame(endDateTime)) {
            // if (startDateTime===endDateTime) {
            data = <div> <p className={styles.requestText}>  {moment.parseZone(start).format('hh:mm A') + " - " + moment.parseZone(End).format('hh:mm A')}</p></div>;
            return data;
        }
        else {
            let multipleDaysArray = null;
            multipleDaysArray = this.splitDates(start, End);
            //get count of records
            if (multipleDaysArray.indexOf(key) === 0) {
                // console.log("First element");
                data = <div> <p className={styles.requestText}> {moment.parseZone(start).format('hh:mm A') + " - 11:59 PM"}</p><span className={styles.requestText}>{"(1 of "}{multipleDaysArray.length + ")"}</span></div>;
                return data;
            }
            else if (multipleDaysArray[multipleDaysArray.length - 1] === key) {
                // console.log("last element");
                data = <div> <p className={styles.requestText}> {"12:00 AM - " + moment.parseZone(End).format('hh:mm A')}</p><span className={styles.requestText}> {"(" + multipleDaysArray.length}{" of "}{multipleDaysArray.length + ")"}</span></div>;
                return data;
            }
            else if (multipleDaysArray.includes(key)) {
                let indexValue = multipleDaysArray.indexOf(key) + 1;
                // In Middle
                data = <div> <p className={styles.requestText}> {"All Day"}</p><span className={styles.requestText}> {"(" + indexValue}{" of "}{multipleDaysArray.length + ")"}</span></div>;
                return data;
            }

            //check if key has index 0 then get 
            //return start time and end time as 11:59 PM 
            //and also return  1 of length of array

            //In Middle 
            //return All Day 
            //Count as [mutlpile array] key index +1 of   length of array 

            //check if key has last index 
            //return start time as 12:00 AM and end time 
            //and also return  length of array of length of array
        }
    }

}


const mapStateToProps = state => {
    return {
        completeRequestsLists: state.facilityRootReducer.requests,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getRequestsList: () => dispatch(getRequestsList()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AfterHoursMyRequests);

